<template>
<div id="app">

	<div v-if="!gameState">
		<div>nombre: </div><input v-model="name">
		<br><br>
		<div>sala: </div><input v-model="room">
		<br><br>
		<button @click="Connect">conectar</button>
	</div>

	<div class="other-players">
		<player v-for="player in oponents" :key="player.id"
		:name="player.name" :id="player.id" :dice="player.dice" :reserve="player.reserve" :visibility="player.visibility"></player>
	</div>

	<div class="center-table" v-if="summary">

		<div class="dice-total">{{summary.total}}</div>

		<div class="dice-details">
			<div v-for="(dice, key) in summary.dice" :key="key" :class="`die-${key}`">
				<span>{{dice.count}}</span>
				<span v-if="dice.total > dice.count"> ({{dice.total}})</span>
				<span> {{dice.icon}}</span>
			</div>
		</div>

	</div>

	<player v-if="activePlayer" is-active-player 
	:name="activePlayer.name" :id="activePlayer.id" :dice="activePlayer.dice" :reserve="activePlayer.reserve" :visibility="activePlayer.visibility"></player>
</div>
</template>

<script>
import Player from './components/Player'
export default {
	name: 'App',
	components: { Player	},
	data() {
		return {
			idPlayer: null,
			gameState: null,
			name: 'jugador',
			room: 'room1'
		}
	},
	methods: {
		Connect() {
			this.$socket.client.io.opts.query = {room: this.room, name: this.name};
        	this.$socket.client.connect();
		}
	},
	computed: {
		activePlayer() {
			if(!this.gameState) return;
			return this.gameState.players.find(el => el.id == this.idPlayer);
		},
		oponents() {
			if(!this.gameState) return [];
			var ret = [];
			var activePlayerIndex = this.gameState.players.findIndex(el => el.id == this.idPlayer);
			if(activePlayerIndex < 0) activePlayerIndex = 0;
			var index = activePlayerIndex;

			for(var i = 0; i < this.gameState.players.length; i++)
			{
				var player = this.gameState.players[index];
				if(player.id !== this.idPlayer) 
				{
					ret.push(player);
				}

				index = (index+1) % this.gameState.players.length;
			}

			return ret;
		},
		summary() {
			if(!this.gameState) return;
			var total = 0;
			var totalDice = {
				1: {count: 0, total: 0, icon: '⚀'},
				2: {count: 0, total: 0, icon: '⚁'},
				3: {count: 0, total: 0, icon: '⚂'},
				4: {count: 0, total: 0, icon: '⚃'},
				5: {count: 0, total: 0, icon: '⚄'},
				6: {count: 0, total: 0, icon: '⚅'},
			}
			
			this.gameState.players.forEach(player => {
				total += player.dice.length;

				if(player.visibility == 'open' || (player.visibility == 'self' && player.id == this.idPlayer) || (player.visibility == 'others' && player.id !== this.idPlayer))
				{
					player.dice.forEach(dice => {
						totalDice[dice].count++;
						totalDice[dice].total++;
						if(dice == 1)
						{
							totalDice[2].total++;
							totalDice[3].total++;
							totalDice[4].total++;
							totalDice[5].total++;
							totalDice[6].total++;
						}
					});
				}

			});

			return {
				total: total,
				dice: totalDice
			};
		}
	},
	sockets: {
		connect() {
			this.idPlayer = this.$socket.client.id;
		},
		UPDATE(data) {
			this.gameState = data;
		},
		SHAKE(data) {
			var el = document.getElementById(data);
			if(!el) return;
			var cup = el.querySelector('.cup');
			if(!cup) return;
			cup.classList.add('shake');
			setTimeout(() => {
				cup.classList.remove('shake');	
			}, 500);
		}
	}

}
</script>

<style lang="scss">
html, body, #app {
	width: 100%;
	height: 100%;
	margin: 0px;
	padding: 0px;
	background: #333f66;
	color: white;
}
* {
	box-sizing: border-box;
	font-family: 'Poppins', sans-serif;
}
#app {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
.center-table {
	height: 100px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: white;
	//border: 2px solid white;
	margin: 20px 0px;
	padding: 0px 20px;
	border-radius: 10px;
	background-color: rgba(0, 0, 0, 0.3);

	.dice-details {
		display: flex;
		font-size: 12px;
		gap: 10px;
	}

	.dice-total {
		margin-bottom: 5px;
		font-size: 40px;
	}

}
.other-players {
	display: flex;
	gap: 20px;
	max-width: 100%;
	flex-wrap: wrap;
	justify-content: center;
}
</style>
